<template>
    <ul class="todo-list-artifact">
        <li
            v-for="todo in data"
            :key="todo.id"
            class="todo-list-artifact__item">
            <div class="todo-list-artifact__circle">
                <div
                    v-if="todo.status === TASK_STATUS.NOT_STARTED"
                    class="todo-list-artifact__pending" />
                <div
                    v-if="todo.status === TASK_STATUS.PENDING"
                    class="todo-list-artifact__progress" />
                <pendo-icon
                    v-if="todo.status === TASK_STATUS.COMPLETED"
                    class="todo-list-artifact__completed"
                    type="check-circle-2-solid"
                    fill="var(--palette-teal-90)"
                    stroke="var(--palette-gray-0)" />
            </div>
            <span
                :class="{
                    'todo-list-artifact__striked-text': todo.status === TASK_STATUS.COMPLETED,
                    'todo-list-artifact__progress-text': todo.status === TASK_STATUS.PENDING }">
                {{ todo.task }}
            </span>
        </li>
    </ul>
</template>

<script>
import { PendoIcon } from '@pendo/components';

export default {
    name: 'TodoListArtifact',
    components: {
        PendoIcon,
    },
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    data () {
        const TASK_STATUS = Object.freeze({
            NOT_STARTED: 'not_started',
            PENDING: 'in_progress',
            COMPLETED: 'completed',
        });

        return {
            TASK_STATUS,
        };
    },
};
</script>

<style scoped lang="less">
.todo-list-artifact {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__item {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  &__circle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border: solid 1px;
    border-color: var(--palette-gray-40);
    border-radius: 50%;
  }

  &__pending {
    width: 10px;
    height: 10px;
    background: var(--palette-gray-40);
    border-radius: 50%;
    animation: fadeIn 0.3s ease-in-out;
  }

  &__progress {
    width: 10px;
    height: 10px;
    background: var(--palette-teal-90);
    border-radius: 50%;
    animation: fadeIn 0.3s ease-in-out;
  }

  &__completed {
    height: inherit;
    animation: fadeIn 0.3s ease-in-out;
  }

  &__progress-text {
    background: radial-gradient(
          circle at 100%,
          var(--palette-gray-80),
          var(--palette-gray-90) 50%,
          var(--palette-gray-60) 75%,
          var(--palette-gray-70) 75%
        );
    background-size: 200% auto;
    color: var(--palette-gray-100);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: animatedTextGradient 2s linear infinite;
  }

  &__striked-text {
    text-decoration: line-through;
    color: var(--palette-teal-90);
    animation: strike 0.3s ease-in-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.5);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  @keyframes strike {
    from {
      text-decoration-color: transparent;
      color: inherit;
    }
    to {
      text-decoration-color: auto;
      color: var(--palette-teal-90);
    }
  }

  @keyframes animatedTextGradient {
      from {
          background-position: 200% center;
        }
      to {
          background-position: 0% center;
        }
  }

  // this style is to add padding whenever this is inside of the artifact component
  :global(.ask-pendo-artifact__content:has(.todo-list-artifact)) {
    padding: 16px;
  }
}
</style>
